export const AUTH_UPDATE = 'AUTH_UPDATE';
export const authUpdate = (authData) => ({type: AUTH_UPDATE, authData});

export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const authLogout = () => ({type: AUTH_LOGOUT});



/** WEBPACK FOOTER **
 ** ./src/members/state/auth/actions.js
 **/